export default __webpack_public_path__ + "static/media/pic34-after.3d4b0d31.jpg";